export default "__VITE_ASSET__B8or18jv__"